import { render, staticRenderFns } from "./BillPermissions.vue?vue&type=template&id=2ae30334&scoped=true"
import script from "./BillPermissions.vue?vue&type=script&lang=js"
export * from "./BillPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae30334",
  null
  
)

export default component.exports